import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { CONTACT } from "@/data/site";
import { Reveal } from "@/components/site/Motion";

export const CtaBand = () => (
  <section data-testid="cta-band" className="relative overflow-hidden bg-[#C8D484] text-black">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-32 lg:px-12">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em]">Vamos conhecer o seu cão</p>
        <h2 className="mt-6 max-w-5xl font-display text-6xl font-semibold uppercase leading-[0.88] tracking-tight sm:text-8xl lg:text-[8.5rem]">
          Marque uma visita <span className="font-serif font-normal normal-case italic tracking-normal">às instalações.</span>
        </h2>
      </Reveal>
      <div className="mt-12 flex flex-wrap gap-4">
        <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
          <Link to="/contacto" data-testid="cta-band-contact" className="group inline-flex items-center gap-3 rounded-full bg-black px-8 py-4 font-bold text-[#C8D484]">
            Pedir orçamento <ArrowUpRight className="h-5 w-5 transition-transform group-hover:rotate-45" />
          </Link>
        </motion.div>
        <motion.a whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }} href={CONTACT.phoneHref} data-testid="cta-band-phone" className="inline-flex items-center rounded-full border-2 border-black px-8 py-4 font-bold">
          {CONTACT.phone}
        </motion.a>
      </div>
    </div>
  </section>
);
